import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component, EventEmitter,
    Input,
    OnChanges, OnDestroy,
    OnInit, Output,
    SimpleChanges, ViewChild
} from '@angular/core';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {SensorsDialogComponent} from '../sensors-dialog/sensors-dialog.component';
import {UnitPublicService} from "../../../services/public/unit-public.service";
import {Observable} from "rxjs";
import {filter, forEach, orderBy, sortBy} from "lodash";
import {StorageLocationService} from "../../../modules/admin/services/storage-location.service";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {formatOpeningHours} from "../../opening-hours";
import {CarouselComponent, OwlOptions} from 'ngx-owl-carousel-o';
import {Subject, takeUntil} from 'rxjs';
import {ViewportService} from 'app/services/viewport.service';

@Component({
    selector: 'app-location-list',
    templateUrl: './location-list.component.html',
    styleUrls: ['./location-list.component.scss'],
})
export class LocationListComponent implements OnInit, OnChanges, OnDestroy {
    @Input() locations: any[] = [];
    @Input() userLocation = null;
    @Input() highlightListItem;
    @Output() panTo: EventEmitter<{ lat: number; lng: number }> = new EventEmitter<{ lat: number; lng: number }>();
    @ViewChild(CdkVirtualScrollViewport) viewPort: CdkVirtualScrollViewport;
    @ViewChild(CarouselComponent) carousel: CarouselComponent;

    formatOpeningHours = formatOpeningHours;
    mobile: boolean = false;

    // Mobil: eine Karte pro Ansicht, wischen zwischen Standorten, Punkte darunter
    carouselOptions: OwlOptions = {
        autoplay: false,
        loop: false,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: false,
        dots: true,
        nav: false,
        navText: ['', ''],
        // Keine autoHeight: alle Karten gleich hoch (Platzhalter-Logo ersetzt fehlende Fotos),
        // sonst springt die Höhe beim Wischen. items über responsive wie bei den anderen Carousels,
        // sonst rechnet Owl beim Re-Init falsche Breiten.
        responsive: {
            0: {
                items: 1,
            },
        },
    };

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        public dialog: MatDialog,
        private router: Router,
        private unitService: UnitPublicService,
        private locationService: StorageLocationService,
        private viewport: ViewportService,
    ) {
    }

    ngOnInit(): void {
        this.viewport.isMobile$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((mobile) => (this.mobile = mobile));
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }


    ngOnChanges(changes: SimpleChanges): void {
        forEach(this.locations, (location) => {
            this.getFreeUnits(location._id).subscribe(
                {
                    next: (data) => {
                        location.freeUnits = filter(data, {status: 'free'});
                        location.distanceToUser = this.calculateDistanceToUser(location.gpsLocation, this.userLocation);
                    },
                    error: () => {
                    },
                    complete: () => {
                        this.locations = sortBy(this.locations, ['distanceToUser']);
                    }
                });
        });

        if (changes.highlightListItem?.currentValue) {
            const selectedIndex = this.locations.findIndex(elem => elem._id === this.highlightListItem?.id);
            if (selectedIndex > -1) {
                // Desktop-Liste scrollt, mobiles Carousel wischt zur Karte (Slide-Id = Standort-Id)
                this.viewPort?.scrollToIndex(selectedIndex, 'smooth');
                this.carousel?.to(this.highlightListItem.id);
            }
        }
    }

    showServicesDialog(event, location: any): void {
        event.stopPropagation();
        const dialogRef = this.dialog.open(SensorsDialogComponent, {
            width: '350px',
            data: {
                location: location
            },
        });
    }

    calculateDistanceToUser(start: any, end: any): string {
        if (start && end) {
            return this.getDistanceBetweenTwoPoints({
                lat: start.latitude,
                lng: start.longitude,
            }, end).replace('.', ',');
        }
    }

    getDistanceBetweenTwoPoints(cord1, cord2): string {
        if (cord1.lat === cord2.lat && cord1.lng === cord2.lng) {
            return '0';
        }

        const radlat1 = (Math.PI * cord1.lat) / 180;
        const radlat2 = (Math.PI * cord2.lat) / 180;

        const theta = cord1.lng - cord2.lng;
        const radtheta = (Math.PI * theta) / 180;

        let dist =
            Math.sin(radlat1) * Math.sin(radlat2) +
            Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);

        if (dist > 1) {
            dist = 1;
        }

        dist = Math.acos(dist);
        dist = (dist * 180) / Math.PI;
        dist = dist * 60 * 1.1515;
        dist = dist * 1.609344; //convert miles to km

        return dist.toFixed(1);
    }


    naviagteToLocation(location: any): void {
        this.router.navigateByUrl(`/home/booking?location=${location._id}`);
    }


    getFreeUnits(locationId: string): Observable<any> {
        return this.unitService.getUnitsForLocation(locationId);
    }

    clickSetLocation(location: any): void {
        this.locationService.setCurrentLocation(location);
        this.panMap(location);
    }

    panMap(location: any): void {
        this.panTo.next({lat: location.gpsLocation.latitude, lng: location.gpsLocation.longitude});
    }
}
